/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, discounted: NonNullable<unknown>, total: NonNullable<unknown> }} Partner_Billing_Board_Discount_MixedInputs */



/**
* | output |
* | --- |
* | "{amount} below list · {discounted} of {total} periods discounted" |
*
* @param {Partner_Billing_Board_Discount_MixedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_discount_mixed = /** @type {((inputs: Partner_Billing_Board_Discount_MixedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Discount_MixedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.amount} unter Listenpreis · ${i?.discounted} von ${i?.total} Zeiträumen rabattiert`)
	return /** @type {LocalizedString} */ (`${i?.amount} below list · ${i?.discounted} of ${i?.total} periods discounted`)
});